import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Button, Drawer, Icon, Menu, MenuItem } from '@blueprintjs/core';
import { IconSize } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';

import { Pannellum } from '$root/components/pannellum-react-local';


function SingleDocumentView(props, ref) {

    const { visible, image, pitch, yaw, onRender, onLoad, onMouseDown, onMouseUp } = props;

    return (
        <>
            <div style={{
                position: 'relative',
                width:'100%',
                height:'100%',
                padding:2,
                visibility: visible ? 'visible' : 'hidden',
            }}>
                <Pannellum
                    ref={ref}
                    width="100%"
                    height="100%"
                    image={image}
                    pitch={pitch}
                    yaw={yaw}
                    hfov={90}
                    vaov={180}
                    friction={1.0}
                    showFullscreenCtrl={false}
                    showControls={false}
                    keyboardZoom={false}
                    disableKeyboardCtrl={true}
                    doubleClickZoom={false}
                    compass={false}
                    autoLoad
                    style={{flexGrow:1}}
                    animationTimingFunction={() => 1 }
                    onRender={onRender}
                    onLoad={() => onLoad && onLoad()}
                    onMousedown={() => onMouseDown && onMouseDown()}
                    onMouseup={() => onMouseUp && onMouseUp()}
                />
            </div>
        </>
    );
}


export default React.forwardRef(SingleDocumentView);


SingleDocumentView.propTypes = {
    visible:PropTypes.bool.isRequired,
    image:PropTypes.object.isRequired,
    pitch:PropTypes.number.isRequired,
    yaw:PropTypes.number.isRequired,
    onRender:PropTypes.func.isRequired,
    onLoad:PropTypes.func.isRequired,
}